<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container>
            <v-alert v-model="alert"
                     border="left"
                     transition="scale-transition"
                     dismissible
                     close-text="Close Alert"
                    type="warning" outlined class=" my-0">
              Για να μπορέσετε να προχωρήσετε στην αποστολή συγγραμμάτων μέσω Courier, θα πρέπει να προηγηθεί η σύναψη σύμβασης με την εταιρεία Ταχυμεταφορές ΕΛΤΑ Α.Ε.
              Στοιχεία Επικοινωνίας: Κωνσταντίνος Λαμπρόπουλος k.lambropoulos@elta-courier.gr Σταθερό: 2106073129 Κινητό: 6936872308 Ώρες επικοινωνίας: 9:00 - 16:00
            </v-alert>
            <v-row>
                <v-col>
                    <v-card class="elevation-6">
                        <v-card-text>
                            <v-toolbar color="white" flat>
                                <v-toolbar-title>Διανομή Courier</v-toolbar-title>
                                <v-icon v-if="!alert" @click="alert = true" color="warning">info</v-icon>
                                <v-spacer></v-spacer>
                                <v-speed-dial
                                        class="mb-8"
                                        color="primary" dark direction="left" fab open-on-hover
                                        right
                                        top
                                        v-model="fab">
                                    <template v-slot:activator>
                                        <v-badge v-if="checkedItem.length > 0"
                                                overlap
                                                 color="red"
                                                 :content="checkedItem.length">
                                        <v-btn color="primary"
                                               dark
                                               fab
                                               small
                                               v-model="fab">
                                            <v-icon v-if="fab">mdi-close</v-icon>
                                            <v-icon v-else>add</v-icon>
                                        </v-btn>
                                        </v-badge>
                                        <v-btn v-else
                                                color="primary"
                                               dark
                                               fab
                                               small
                                               v-model="fab">
                                            <v-icon v-if="fab">mdi-close</v-icon>
                                            <v-icon v-else>add</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-if="$store.getters.homePageInformation.bookDeliveryAllowedPeriod"
                                                   @click="startOrCancelStatementBooksVoucher('start')"
                                                   color="primary"
                                                   dark
                                                   fab
                                                   small
                                                   v-on="on">
                                                <v-icon>send</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Έναρξη Αποστολής των Επιλεγμένων Βιβλίων</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-if="$store.getters.homePageInformation.bookReturnAllowedPeriod"
                                                   @click="startOrCancelStatementBooksVoucher('stop')"
                                                   color="primary"
                                                   dark
                                                   fab
                                                   small
                                                   v-on="on">
                                                <v-icon>reply</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Ακύρωση Αποστολής των Επιλεγμένων Βιβλίων</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="printLabel"
                                                   color="primary"
                                                   dark
                                                   fab
                                                   small
                                                   v-on="on">
                                                <v-icon>print</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Εκτύπωση Ετικετών</span>
                                    </v-tooltip>
                                </v-speed-dial>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="openManual"
                                           class="mr-4"
                                           color="primary"
                                           dark
                                           fab
                                           small
                                           v-on="on">
                                      <v-icon>description</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Εγχειρίδιο</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click="openDatePicker"
                                               color="primary"
                                               dark
                                               fab
                                               small
                                               v-on="on">
                                            <v-icon>get_app</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Επιλογές Βιβλίων από Φοιτητές - Διανομή μέσω Courier</span>
                                </v-tooltip>
                            </v-toolbar>
                            <v-divider></v-divider>

                            <v-card-title>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                                append-icon="search"
                                                hide-details
                                                label="Αναζήτηση"
                                                single-line
                                                v-model="search"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-select @blur="resetSelector"
                                                  :items="selectItems"
                                                  @change="getStatus"
                                                  class="mt-3 mr-4"
                                                  dense
                                                  item-text="label"
                                                  label="Κατάσταση"
                                                  outlined
                                                  return-object
                                                  v-model="status"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-card-title>

                            <v-data-table
                                    :headers="headers"
                                    :items="$store.getters.courier"
                                    :search="search"
                                    item-key="selectedBookId"
                                    no-data-text="Δεν υπάρχουν δεδομένα.">
                                <template v-slot:item.selectedByPublisher="{ item }">
                                            <v-checkbox @change="bookChecked(item)" class="pa-0" :input-value="checkCheckBox(item)"
                                                    color="warning"></v-checkbox>
                                </template>

                                <template v-slot:item.status="{ item }">
                                    {{returnStatusInTable(item.status)}}
                                </template>

                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <div class="text-center">
            <v-dialog persistent
                      max-width="500"
                      v-model="datePicker">
                <v-card flat>
                    <div class="text-center">
                        <v-date-picker :max="maxDate" :min="minDate"
                                       class="elevation-0"
                                       :events="arrayEvents"
                                       full-width
                                       range
                                       color="primary"
                                       first-day-of-week="1"
                                       locale="el"
                                       v-model="dates"></v-date-picker>
                    </div>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn
                                @click="closeDatePicker"
                                color="primary"
                                text>
                            Ακύρωση
                        </v-btn>
                        <v-btn  :loading=" $store.getters.publisherBooksFromCourierDeliveredPdf.isLoading"
                                :disabled="dates.length == 0"
                                @click="startServicePublisherBooksFromCourierDeliveredPdfMethod"
                                color="primary"
                                text>
                            <v-icon>get_app</v-icon>pdf
                        </v-btn>
                        <v-btn  :loading="$store.getters.publisherBooksFromCourierDeliveredXlsx.isLoading"
                                :disabled="dates.length == 0"
                                @click="startServicePublisherBooksFromCourierDeliveredXlsxMethod"
                                color="primary"
                                text>
                            <v-icon>get_app</v-icon>xlsx
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<script>

    import request from '../../requests'
    import utils from '../../utilities'
    import service from '../../service'

    export default {
        name: "Courier",
        data: () => ({
            form: {
                parent_id: []
            },
            checkbox: true,
            alert: true,
            checkedItem: [],
            datePicker: false,
            minDate: '',
            maxDate: '',
            dates: [],
            arrayEvents: [],
            fab: false,
            status: {},
            search: '',
            statementbooksToUpdate:0,
            statementbooksAfterUpdate:0,
            headers: [
                {
                    text: 'Επιλογή',
                    align: 'start',
                    sortable: true,
                    value: 'selectedByPublisher'
                },
                {
                    text: 'Κωδικός',
                    align: 'start',
                    sortable: true,
                    value: 'book.id'
                },
                {text: 'Τίτλος Βιβλίου', value: 'bookTitle', align: 'center', sortable: true,},
                {text: 'Τόμος', value: 'book.volumeNumber', align: 'center', sortable: true,},
                {text: 'Όνομα', value: 'studentFirstName', align: 'center', sortable: true,},
                {text: 'Επώνυμο', value: 'studentLastName', align: 'center', sortable: true,},
                {text: 'ΑΜ', value: 'studentAM', align: 'center', sortable: true,},
                {text: 'Κατάσταση', value: 'status', align: 'center', sortable: true,},
                {text: 'Voucher', value: 'voucherNo', align: 'center', sortable: true,}
            ],
            selectItems: [
                {id: 0, label: 'ΟΛΕΣ', value: 'ALL'},
                {id: 1, label: 'Επιλεγμένο απο φοιτητή', value: 'INSERTED'},
                {id: 2, label: 'Προετoιμασία για αποστολή', value: 'GOT_VOUCHER'},
                {id: 3, label: 'Παραλήφθηκε απο Courier', value: 'PICKED_UP'},
                {id: 4, label: 'Αναμονή παραλαβής απο φοιτητή', value: 'ARRIVED'},
                {id: 5, label: 'Παραδόθηκε σε φοιτητή', value: 'DELIVERED'},
                {id: 6, label: 'Επιστράφηκε σε εκδότη', value: 'RETURNED'},
                {id: 7, label: 'Ακυρώθηκε', value: 'CANCELED'},
            ]
        }),

        methods: {

            resetSelector() {
                this.status = {};
            },

            getStatus() {

                this.getCourier();
            },

            openDatePicker(){
                this.maxDate = utils.createPickerCurrentDate();
                this.dates= [];
                this.datePicker = true;
            },

            closeDatePicker(){
                this.dates = [];
                this.datePicker = false;
            },

            startServicePublisherBooksFromCourierDeliveredPdfMethod() {
                this.dates = utils.sortDatesArray(this.dates);
                service.startServicePublisherBooksFromCourierDeliveredPdf(this.dates);
            },
            startServicePublisherBooksFromCourierDeliveredXlsxMethod() {
                this.dates = utils.sortDatesArray(this.dates);
                service.startServicePublisherBooksFromCourierDeliveredXlsx(this.dates);
            },

            printLabel() {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.voucherPrint(token, this.checkedItem)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }

            },

            startOrCancelStatementBooksVoucher(action) {
                var courierVoucherModel = {
                    statementBookIds: [],
                    action: action
                };
                for(var i = 0 ; i< this.checkedItem.length; i++){
                    courierVoucherModel.statementBookIds[i] = this.checkedItem[i].id;
                }
                this.statementbooksToUpdate =   courierVoucherModel.statementBookIds.length;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.startOrCancelStatementBooksVoucher(token, courierVoucherModel, this.startOrCancelStatementBooksVoucherCallBack);
                    this.$store.commit('setParticipationModal', false);
                } else {
                    this.$store.commit('setloginModal', true);
                }

            },

            bookChecked(item) {

                var isExist = false;
                var temp = -1;
                for (var i = 0; i < this.checkedItem.length; i++) {
                    if (item.id == this.checkedItem[i].id) {
                        isExist = true;
                        temp = i
                    }
                }

                if (isExist) {
                    this.checkedItem.splice(temp,1);
                }
                else {
                    delete item.selectedByPublisher;
                    this.checkedItem.push(item)
                }


            },

            checkCheckBox(item) {

                for (var i = 0; i < this.checkedItem.length; i++) {
                    if (this.checkedItem[i].id == item.id) {
                        return true
                    }
                }
                return false
            },

            getCourier(){

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getCourier(token, this.status.value, this.getCourierCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getCourierCallBack(response){

                this.$store.commit('setCourier', response);
                this.$store.commit('setLoadingModal', false);
            },

            startOrCancelStatementBooksVoucherCallBack(response){
                var courierStatementBooks = JSON.parse(JSON.stringify(this.$store.getters.courier));

                this.checkedItem = []; // clear and fill with updated values
                for(var i=0; i<response.updatedStatementBooksList.length; i++){
                    for(var j=0; j<courierStatementBooks.length; j++){
                        if(response.updatedStatementBooksList[i].id == courierStatementBooks[j].id){
                            courierStatementBooks[j] = response.updatedStatementBooksList[i];
                            this.checkedItem.push(response.updatedStatementBooksList[i]);// here we update the checked items from table
                            break;
                        }
                    }
                }

                this.$store.commit('setCourier', courierStatementBooks);
                this.$store.commit('setLoadingModal', false);

                if(response.updatedStatementBooksList.length === this.statementbooksToUpdate){
                    utils.setSuccessPopup(response.totalUpdated,false);
                }else{
                    utils.setErrorPopup(response.totalUpdated);
                }

            },

            returnStatusInTable(status) {

                var returnStatus = '';
                switch (status) {
                    case 'INSERTED':
                        returnStatus = "Επιλεγμένο από φοιτητή";
                        break;
                    case 'GOT_VOUCHER':
                        returnStatus = "Προετοιμασία για αποστολή";
                        break;
                    case 'PICKED_UP':
                        returnStatus = "Παραλήφθηκε από courier";
                        break;
                    case 'ARRIVED':
                        returnStatus = "Αναμονή παραλαβής από φοιτητή";
                        break;
                    case 'DELIVERED':
                        returnStatus = "Παραδόθηκε σε φοιτητή";
                        break;
                    case 'RETURNED':
                        returnStatus = "Επιστράφηκε σε εκδότη";
                        break;
                    case 'EXPIRED':
                        returnStatus = "Δεν παραλήφθηκε από φοιτητή";
                        break;
                    case 'CANCELED':
                        returnStatus = "Ακυρώθηκε";
                }
                return returnStatus
            },

          openManual() {
            window.open('https://eudoxus.gr/files/Courier_deliv_instr_2022.pdf', '_blank');
          },
        },

        watch:{
            'checkedItem': function (val){
                console.log(val);
            }
        },

        created() {
            window.scrollTo(0, 0);
            //this.status = {selectedBookId: 0, label: 'ΟΛΕΣ', value: 'ALL'};
            //this.getCourier();
        }
    }
</script>

<style scoped>
</style>
